import { render, staticRenderFns } from "./LandPageA.vue?vue&type=template&id=7f02cfc8&scoped=true"
import script from "./LandPageA.vue?vue&type=script&lang=js"
export * from "./LandPageA.vue?vue&type=script&lang=js"
import style0 from "./LandPageA.vue?vue&type=style&index=0&id=7f02cfc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f02cfc8",
  null
  
)

export default component.exports